import { Select } from 'antd';
import styled from 'styled-components';

interface StyledProps {
  readOnly?: boolean;
}

export const Container = styled.div<StyledProps>`
  position: relative;
  margin-bottom: 1rem;

  ${({ readOnly, theme }) =>
    readOnly &&
    ` .hefesto-input-wrapper.hefesto-input-wrapper--disabled {
        opacity: 1;
        .hefesto-select.select--disabled {
          opacity: 1;

          .hefesto-select__input:disabled {
            background-color: ${theme.colors.gray8};
            border-color:  ${theme.colors.gray8};
            cursor: pointer;
          }
        }
  }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: unset;
  }

  & > span.no-contracts,
  > span.closed-contract {
    display: block;
    font-size: 0.75rem;
    margin: 0.25rem;
    width: 18rem;
    color: ${({ theme }) => theme.colors.red};
    position: absolute;

    animation: contractAlertMessage 0.5s ease;

    @keyframes contractAlertMessage {
      from {
        transform: translateY(-0.25rem);
      }
      to {
        transform: translateY(0);
      }
    }
  }
`;

export const ContractsSelect = styled(Select)`
  width: 100%;

  &.ant-select-single.ant-select-show-arrow {
    & > div.ant-select-selector {
      padding: 0 0.5rem;
    }
  }

  & .ant-select-selection-placeholder {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark};
  }

  & .ant-select-selection-search {
    left: 8px !important;
  }

  & .ant-select-selection-item > div {
    display: inline-block;
    width: 99%;
    white-space: nowrap;
    /* overflow: hidden; */
    text-overflow: ellipsis;

    & > span.contract-customer-order {
      color: ${({ theme }) => theme.colors.black};
      font-weight: 400;
    }

    & > span.contract-date,
    & > span.customer-name {
      display: none;
    }
  }
`;

export const CustomFabricationSelectOptionContent = styled.div`
  display: flex;
  flex-direction: column;

  & > span {
    font-size: 0.75rem;

    &.contract-customer-order {
      color: ${({ theme }) => theme.colors.grayDark2};
      font-weight: 700;
    }

    &.contract-date,
    &.customer-name {
      color: ${({ theme }) => theme.colors.graySubTitle};
    }
  }
`;
